import styled from 'styled-components';

export const Img = styled.img`
    background: rgba(0, 0, 0, 0.1);
    border: dashed 2px rgba(0, 0, 0, 0.64);
    border-radius: 8px;
    display: inline-block;
    font-size: inherit;
    height: 60px;
    margin-bottom: 1em;
    padding: 12px;
    width: 60px;
`;

export const Container = styled.div`
    display: inline-block;
    &:hover label{
        display: flex;
        text-decoration: underline;
        text-transform: uppercase;
    }
`;

export const LabelButton = styled.label`
    align-items: center;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.84);
    color: white;
    display: none;
    font-size: 11px;
    height: 56px;
    justify-content: center;
    overflow: hidden;
    position: absolute;
    margin-left: 2px;
    margin-top: 2px;
    transition: 2s;
    width: 56px;
    &:hover{
        cursor: pointer;
    }
`;